import { MissingBoxesAlertStatus } from "@deliverr/commons-clients";

export const isCreatedShortShip = (status: MissingBoxesAlertStatus) => status === MissingBoxesAlertStatus.CREATED;
